import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-petition-groups-main',
		path: '/admin/petition_groups/:id',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_petition_groups_main" */ './index'), {
			exportName: 'AdminPetitionGroupsMain',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['support', 'campaigns'],
		},
		frame: true,
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
